import * as o from "react";
import a from "../lib/SSRBase.es.js";
import d from "../defs/RedditLogo.es.js";
const e = o.forwardRef((t, r) => /* @__PURE__ */ o.createElement(a, { ref: r, ...t, weights: d }));
e.displayName = "RedditLogoIcon";
const s = e;
export {
  s as RedditLogo,
  e as RedditLogoIcon
};
